export default __webpack_public_path__ + "static/media/third-image2.302db313.jpg";